// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: 07P6RC82cGJP

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component
import NewsLetter from "../../NewsLetter"; // plasmic-import: hz7eRhzEc6/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicResourceModal2.module.css"; // plasmic-import: 07P6RC82cGJP/css

import LinksvgIcon from "./icons/PlasmicIcon__Linksvg"; // plasmic-import: wup7cgCFLJ/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: QKCDMAfoLkN/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: Q_1iLw7C4y/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: mEWqrtEPYf/icon

createPlasmicElementProxy;

export type PlasmicResourceModal2__VariantMembers = {};
export type PlasmicResourceModal2__VariantsArgs = {};
type VariantPropType = keyof PlasmicResourceModal2__VariantsArgs;
export const PlasmicResourceModal2__VariantProps = new Array<VariantPropType>();

export type PlasmicResourceModal2__ArgsType = {
  resourceDescription?: React.ReactNode;
  resourceName?: React.ReactNode;
  logoSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  resourceLink?: React.ReactNode;
};
type ArgPropType = keyof PlasmicResourceModal2__ArgsType;
export const PlasmicResourceModal2__ArgProps = new Array<ArgPropType>(
  "resourceDescription",
  "resourceName",
  "logoSrc",
  "resourceLink"
);

export type PlasmicResourceModal2__OverridesType = {
  root?: p.Flex<"div">;
  columns?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  resourceName?: p.Flex<"h1">;
  span?: p.Flex<"span">;
  visitSite?: p.Flex<typeof Button>;
  shareButtons?: p.Flex<"div">;
  shareSite?: p.Flex<typeof Button>;
  newsLetter?: p.Flex<typeof NewsLetter>;
};

export interface DefaultResourceModal2Props {
  resourceDescription?: React.ReactNode;
  resourceName?: React.ReactNode;
  logoSrc?: React.ComponentProps<typeof p.PlasmicImg>["src"];
  resourceLink?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicResourceModal2__RenderFunc(props: {
  variants: PlasmicResourceModal2__VariantsArgs;
  args: PlasmicResourceModal2__ArgsType;
  overrides: PlasmicResourceModal2__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          logoSrc:
            "https://firebasestorage.googleapis.com/v0/b/ideahub-b5d59.appspot.com/o/brandmark-icon-filled-256.png?alt=media&token=f3fb077a-d37c-4675-91b6-8caabb398b29"
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__odF1N)}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"columns"}
          data-plasmic-override={overrides.columns}
          hasGap={true}
          className={classNames(projectcss.all, sty.columns)}
        >
          <div className={classNames(projectcss.all, sty.column__bJoWr)}>
            <p.PlasmicImg
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"256px"}
              displayMaxWidth={"256px"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"100%"}
              loading={"lazy"}
              src={args.logoSrc}
            />
          </div>
          <div className={classNames(projectcss.all, sty.column__c29Ie)}>
            <div className={classNames(projectcss.all, sty.freeBox__clWqc)}>
              <div className={classNames(projectcss.all, sty.freeBox__c7SsI)}>
                <h1
                  data-plasmic-name={"resourceName"}
                  data-plasmic-override={overrides.resourceName}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    sty.resourceName
                  )}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "You won't believe what happens next.",
                    value: args.resourceName,
                    className: classNames(sty.slotTargetResourceName)
                  })}
                </h1>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__grSgF)}>
                <LinksvgIcon
                  className={classNames(projectcss.all, sty.svg__vJcda)}
                  role={"img"}
                />

                <span
                  data-plasmic-name={"span"}
                  data-plasmic-override={overrides.span}
                  className={classNames(
                    projectcss.all,
                    projectcss.span,
                    sty.span
                  )}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "www.websitelink.com",
                    value: args.resourceLink
                  })}
                </span>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__oRihh)}>
                <Button
                  data-plasmic-name={"visitSite"}
                  data-plasmic-override={overrides.visitSite}
                  className={classNames("__wab_instance", sty.visitSite)}
                  color={"green"}
                  link={"brandmark.io"}
                  target={true}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__z40Ns
                    )}
                  >
                    {"Visit Site"}
                  </div>
                </Button>
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"shareButtons"}
                data-plasmic-override={overrides.shareButtons}
                hasGap={true}
                className={classNames(projectcss.all, sty.shareButtons)}
              >
                <Button
                  data-plasmic-name={"shareSite"}
                  data-plasmic-override={overrides.shareSite}
                  className={classNames("__wab_instance", sty.shareSite)}
                  color={"softSand"}
                  showStartIcon={true}
                  startIcon={
                    <Icon2Icon
                      className={classNames(projectcss.all, sty.svg__xVb64)}
                      role={"img"}
                    />
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__d3Mi0
                    )}
                  >
                    {"Share"}
                  </div>
                </Button>
                <Button
                  className={classNames("__wab_instance", sty.button___2Pm3C)}
                  color={"blue"}
                  showStartIcon={true}
                  startIcon={
                    <Icon4Icon
                      className={classNames(projectcss.all, sty.svg__qrU9D)}
                      role={"img"}
                    />
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___2Qc7S
                    )}
                  >
                    {"Facebook"}
                  </div>
                </Button>
                <Button
                  className={classNames("__wab_instance", sty.button__oTmQj)}
                  color={"red"}
                  showStartIcon={true}
                  startIcon={
                    <Icon4Icon
                      className={classNames(projectcss.all, sty.svg__vXdCw)}
                      role={"img"}
                    />
                  }
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__igaAt
                    )}
                  >
                    {"Reddit"}
                  </div>
                </Button>
              </p.Stack>
            </div>
          </div>
        </p.Stack>
      </div>
      <NewsLetter
        data-plasmic-name={"newsLetter"}
        data-plasmic-override={overrides.newsLetter}
        className={classNames("__wab_instance", sty.newsLetter)}
      />

      <div className={classNames(projectcss.all, sty.freeBox__tsU5)}>
        {p.renderPlasmicSlot({
          defaultContents:
            "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature",
          value: args.resourceDescription,
          className: classNames(sty.slotTargetResourceDescription)
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "columns",
    "img",
    "resourceName",
    "span",
    "visitSite",
    "shareButtons",
    "shareSite",
    "newsLetter"
  ],
  columns: [
    "columns",
    "img",
    "resourceName",
    "span",
    "visitSite",
    "shareButtons",
    "shareSite"
  ],
  img: ["img"],
  resourceName: ["resourceName"],
  span: ["span"],
  visitSite: ["visitSite"],
  shareButtons: ["shareButtons", "shareSite"],
  shareSite: ["shareSite"],
  newsLetter: ["newsLetter"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  columns: "div";
  img: typeof p.PlasmicImg;
  resourceName: "h1";
  span: "span";
  visitSite: typeof Button;
  shareButtons: "div";
  shareSite: typeof Button;
  newsLetter: typeof NewsLetter;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicResourceModal2__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicResourceModal2__VariantsArgs;
    args?: PlasmicResourceModal2__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicResourceModal2__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicResourceModal2__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicResourceModal2__ArgProps,
          internalVariantPropNames: PlasmicResourceModal2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicResourceModal2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicResourceModal2";
  } else {
    func.displayName = `PlasmicResourceModal2.${nodeName}`;
  }
  return func;
}

export const PlasmicResourceModal2 = Object.assign(
  // Top-level PlasmicResourceModal2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    columns: makeNodeComponent("columns"),
    img: makeNodeComponent("img"),
    resourceName: makeNodeComponent("resourceName"),
    span: makeNodeComponent("span"),
    visitSite: makeNodeComponent("visitSite"),
    shareButtons: makeNodeComponent("shareButtons"),
    shareSite: makeNodeComponent("shareSite"),
    newsLetter: makeNodeComponent("newsLetter"),

    // Metadata about props expected for PlasmicResourceModal2
    internalVariantProps: PlasmicResourceModal2__VariantProps,
    internalArgProps: PlasmicResourceModal2__ArgProps
  }
);

export default PlasmicResourceModal2;
/* prettier-ignore-end */
